import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { exchangeSession } from '../lib/authApi';
import { usePublicAuth } from '../context/PublicAuth';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = usePublicAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : '';
    if (!session_id) {
      setErr('Missing session_id in URL.');
      return;
    }

    (async () => {
      try {
        await exchangeSession(session_id);
        // clear the fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        nav('/account', { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || 'Sign-in failed. Please try again.');
      }
    })();
  }, [location.hash, nav, refresh]);

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6">
      <div className="text-center max-w-md" data-testid="auth-callback">
        {err ? (
          <>
            <div className="text-2xl font-extrabold">Sign-in failed</div>
            <p className="mt-2 text-slate-300 text-sm">{err}</p>
            <button onClick={() => nav('/')} className="mt-6 rounded-lg bg-orange-500 hover:bg-orange-600 px-4 py-2 text-sm font-semibold">Back to home</button>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin mx-auto text-orange-400" />
            <div className="mt-4 text-lg font-semibold">Signing you in…</div>
            <p className="mt-1 text-slate-400 text-xs">Just a moment while we verify your Google account.</p>
          </>
        )}
      </div>
    </div>
  );
}
